import { render, staticRenderFns } from "./VueImage.vue?vue&type=template&id=3fd861ff&scoped=true"
import script from "./VueImage.vue?vue&type=script&lang=js"
export * from "./VueImage.vue?vue&type=script&lang=js"
import style0 from "./VueImage.vue?vue&type=style&index=0&id=3fd861ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd861ff",
  null
  
)

export default component.exports